module.exports = __webpack_public_path__ + "static/img/homeZh.ea9edbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homeZh.jpg
// module id = qeiz
// module chunks = 1